import StickyBox from "react-sticky-box";
import { User16 } from "../../imagepath";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useContext } from "react";
import AuthContext from '../../../context/AuthContext';

// eslint-disable-next-line react/prop-types
export default function SchoolSidebar() {
  const location = useLocation();
  const { logoutUser } = useContext(AuthContext);
  var user = JSON.parse(localStorage.getItem("user"));
  console.log(user,'get user');
  const logout = () => {
   
    logoutUser();
    console.log('User logged out');
   
  };

  return (
    <div className="col-xl-3 col-lg-3 theiaStickySidebar">
      <StickyBox offsetTop={20} offsetBottom={20}>
        <div className="settings-widget dash-profile">
          <div className="settings-menu">
            <div className="profile-bg">
              <div className="profile-img">
                  <img src={User16} alt="Img" />
              </div>
            </div>
            <div className="profile-group">
              <div className="profile-name text-center">
                <h4>
                  {user?.name}
                </h4>
                <p>{user?.type === "Individual" ? "Individual Teacher": "School"}</p>

              </div>
            </div>
          </div>
        </div>
        <div className="settings-widget account-settings">
          <div className="settings-menu">
            <h3>Navigation</h3>
            <ul>
              <li className={`nav-item ${location.pathname === '/main-dashboard' ? 'active' : ''}`}>

                <Link to="/main-dashboard" className="nav-link">
                  <i className="bx bxs-book-alt" />
                  Training
                </Link>
              </li>
              {/* <li className={`nav-item ${location.pathname === '/school/school-profile' ? 'active' : ''}`}>

                <Link to="/school/school-profile" className="nav-link">
                  <i className="bx bxs-user" />
                  My Profile
                </Link>
              </li> */}
              {/* <li className={`nav-item ${location.pathname === '/school/school-courses' ? 'active' : ''}`}>
                <Link
                  to="/school/school-courses"
                  className="nav-link"
                >
                  <i className="bx bxs-graduation" />
                  Enrolled Courses
                </Link>
              </li>
              <li className={`nav-item ${location.pathname === '/school/school-quiz' ? 'active' : ''}`}>

                <Link to="/school/school-quiz" className="nav-link">
                  <i className="bx bxs-shapes" />
                  My Quiz Attempts
                </Link>
              </li> */}
              {user?.type !== "Individual" && (
                <li className={`nav-item ${location.pathname === '/add-school-teacher' ? 'active' : ''}`}>
                <Link
                  to="/add-school-teacher"
                  className="nav-link"
                > <i className="bx bxs-shapes" />
                 Add Teacher
                </Link>
              </li>
              )}
                
              {user?.type !== "Individual" && (
                <li className={`nav-item ${location.pathname === '/my-teachers' ? 'active' : ''}`}>
                  <Link
                    to="/my-teachers"
                    className="nav-link"
                  > <i className="bx bxs-shapes" />
                    My Teachers
                  </Link>
                </li>
              )}

              <li className={`nav-item ${location.pathname === '/school-certifications' ? 'active' : ''}`}>
                <Link to="/school-certifications" className="nav-link">
                  <i className="bx bxs-badge-check" />
                  Certifications
                </Link>
              </li>
              
              
              <li className={`nav-item ${location.pathname === '/school-order-history' ? 'active' : ''}`}>
                <Link to="/school-order-history" className="nav-link">
                  <i className="bx bxs-cart" />
                  Order History
                </Link>
              </li>
              <li className={`nav-item ${location.pathname === '/payment' ? 'active' : ''}`}>
                <Link to="/payment" className="nav-link">
                  <i className="bx bx-credit-card" />
                  Payment
                </Link>
              </li>
            </ul>
            <h3>Account Settings</h3>
            <ul>
              {/* <li className={`nav-item ${location.pathname === '/school/school-setting' || location.pathname === '/school/school-change-password' || location.pathname === '/school/school-social-profile' || location.pathname === '/school/school-linked-accounts' || location.pathname === '/school/school-notification' ? 'active' : ''}`}>
                <Link to="/school/school-setting" className="nav-link ">
                  <i className="bx bxs-cog" />
                  Settings
                </Link>
              </li> */}
              <li className="nav-item">
                <Link to={process.env.REACT_APP_URL || "/"} className="nav-link" onClick={logout}>
                  <i className="bx bxs-log-out" />
                  Logout
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </StickyBox>
    </div>
  );
}
